import { useT } from "@/i18n";

export const Marquee = () => {
  const words = useT().marquee;
  const row = (
    <>
      {words.map((w) => (
        <span key={w} className="mx-8 flex items-center gap-8">
          <span className="whitespace-nowrap font-serif text-3xl italic tracking-tight text-ink/80 lg:text-4xl">{w}</span>
          <span className="h-1.5 w-1.5 rounded-full bg-terra" />
        </span>
      ))}
    </>
  );

  return (
    <div className="overflow-hidden border-b border-ink/10 bg-bone py-8" data-testid="editorial-marquee">
      <div className="flex w-max animate-marquee">
        <div className="flex">{row}</div>
        <div className="flex" aria-hidden="true">{row}</div>
      </div>
    </div>
  );
};
